export default "__VITE_ASSET__DHOW7rG0__"